<template>
    <v-dialog v-model="dialog" max-width="610" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">Edit Teacher</h2>

                    <ValidationProvider name="Name" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                        <v-text-field label="Name"
                                      v-model="user.name"
                                      :loading="loadingRequest"
                                      class="mt-5"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Surname" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                        <v-text-field label="Surname"
                                      v-model="user.sur_name"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider vid="phone" name="Phone" :rules="{required : true, regex: /([0][1|3-9]{2})([0-9]{6})/, max: 9}" v-slot="{ errors }">
                        <v-text-field label="Phone"
                                      v-model="user.phone"
                                      maxlength="9"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-phone'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider vid="email" name="Email" rules="required|email" v-slot="{ errors }">
                        <v-text-field label="Email"
                                      type="email"
                                      v-model="user.email"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-email'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-menu ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider name="Date of Birth" rules="required" v-slot="{ errors }">
                                <v-text-field :value="user.date_of_birth"
                                              :loading="loadingRequest"
                                              label="Date of Birth"
                                              readonly
                                              v-bind="attrs"
                                              v-on="on"
                                >
                                    <template v-slot:prepend-inner>
                                        <svg v-svg="'icon-date'" size="15" class="mr-1"></svg>
                                    </template>
                                </v-text-field>
                                <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </template>

                        <v-date-picker :active-picker.sync="activePicker"
                                       v-model="user.date_of_birth"
                                       @change="$refs.menu.save($event)"
                                       :max="moment(new Date()).subtract(0, 'years').toISOString()"
                                       :min="moment(new Date()).subtract(60, 'years').toISOString()"
                                       color="green"
                        ></v-date-picker>
                    </v-menu>

                    <v-card-actions class="d-flex justify-center mt-6">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingSave">Save</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['user_id', 'is_teacher'],
        data(){
            return {
                menu: false,
                dialog: false,
                user: {},
                loadingRequest: false,
                loadingSave: false,
                activePicker: null,
            }
        },

        watch: {
            'dialog' : function (newVal) {
                if(newVal) {
                    this.loadingRequest = true;
                    this.$apiAdmin('users').show(this.user_id).then((res) => {
                        this.user = res.data.user;
                        this.user.is_teacher = this.is_teacher || false;
                    }).finally(() => {
                        this.loadingRequest = false;
                    })
                }
            },

            menu (val) {
                val && setTimeout(() => (this.activePicker = 'YEAR'))
            }
        },
        methods : {
            save() {
                this.loadingSave = true;
                this.$apiAdmin('users').update(this.user, this.user_id)
                    .then(() => {
                        this.user = {};
                        this.$refs.form.reset();
                        this.dialog = false;
                        this.$parent.getData();
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully updated.'});
                    }).catch((err) => {
                    if (err.response.status === 422) this.$refs.form.setErrors(err.response.data);
                }).finally(() => {
                    this.loadingSave = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>